/**
 * Geração de CSV no cliente.
 *
 * Usado apenas para dados AGREGADOS (contagens por segmento), que não contêm
 * dado pessoal. Exportação de contatos passa pelo backend, que registra
 * usuário, filtros e volume para auditoria LGPD.
 *
 * A vantagem de gerar aqui é respeitar exatamente o que está na tela:
 * ordenação e filtros já aplicados, sem repetir essa lógica no servidor.
 */

/**
 * Escapa um campo para CSV.
 * Prefixa valores iniciados por = + - @ com apóstrofo para o Excel não
 * interpretar como fórmula (CSV injection).
 */
const escapar = (valor) => {
  if (valor === undefined || valor === null) return '';
  let s = String(valor);
  if (/^[=+\-@]/.test(s)) s = `'${s}`;
  if (/[",\n\r;]/.test(s)) s = `"${s.replace(/"/g, '""')}"`;
  return s;
};

/**
 * Monta o conteúdo CSV.
 * @param {Array<{chave: string, titulo: string, formatar?: Function}>} colunas
 * @param {Array<Object>} linhas
 */
export const montarCsv = (colunas, linhas) => {
  const cabecalho = colunas.map(c => escapar(c.titulo)).join(',');
  const corpo = linhas.map(linha =>
    colunas
      .map(c => escapar(c.formatar ? c.formatar(linha[c.chave], linha) : linha[c.chave]))
      .join(','),
  );
  return [cabecalho, ...corpo].join('\n');
};

/**
 * Dispara o download de um CSV.
 * Inclui BOM UTF-8, sem o qual o Excel quebra a acentuação.
 * Não duplica o BOM quando o conteúdo já vem com ele do backend — BOM em
 * dobro aparece como caractere estranho na primeira célula.
 */
export const baixarCsv = (nomeArquivo, conteudo) => {
  const texto = String(conteudo ?? '');
  const comBom = texto.startsWith('\uFEFF') ? texto : '\uFEFF' + texto;
  const blob = new Blob([comBom], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nomeArquivo.endsWith('.csv') ? nomeArquivo : `${nomeArquivo}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

/** Sufixo de data para nome de arquivo: 2026-08-26 */
export const stampData = () => new Date().toISOString().slice(0, 10);
